<!--
  Un titre de section, avec son sous-titre en prose.

  Le sous-titre n'est pas décoratif : c'est ce qui distingue un tableau de bord
  d'un tas de chiffres. Le prop est optionnel techniquement, obligatoire en
  pratique — une section dont on ne peut pas dire en une phrase ce qu'elle
  montre n'a pas sa place.
-->
<template>
  <div class="hv2-sec">
    <div class="hv2-sec-head">
      <div>
        <h4 class="hv2-sec-title">{{ title }}</h4>
        <p v-if="sub" class="hv2-sec-sub">{{ sub }}</p>
      </div>
      <div v-if="$slots.actions" class="hv2-sec-actions"><slot name="actions" /></div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HvSection',
  props: {
    title: { type: String, required: true },
    sub: { type: String, default: '' }
  }
}
</script>
